import { styled } from '@mui/material';
import {
  RESOURCE_SECTION_CARD_GUTTER,
  RESOURCE_SECTION_MAX_WIDTH,
  RESOURCE_SECTION_PADDING,
} from 'themes/constants';

/**
 * Width-capped column (header, ResourceCardGrid, footer) for resource sections. The maxWidth
 * fits exactly RESOURCE_CARDS_PER_ROW design-width cards, which caps ResourceCardGrid's count per row.
 */
export const ResourceSectionFrame = styled('div')(({ theme }) => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  gap: RESOURCE_SECTION_CARD_GUTTER,
  width: '100%',
  maxWidth: RESOURCE_SECTION_MAX_WIDTH.xs,
  // Once maxWidth caps the row, center it instead of leaving the leftover space on the right.
  margin: '0 auto',
  paddingInline: theme.spacing(RESOURCE_SECTION_PADDING.xs),
  [theme.breakpoints.up('sm')]: {
    maxWidth: RESOURCE_SECTION_MAX_WIDTH.sm,
    paddingInline: theme.spacing(RESOURCE_SECTION_PADDING.sm),
  },
  [theme.breakpoints.up('md')]: {
    maxWidth: RESOURCE_SECTION_MAX_WIDTH.md,
    paddingInline: theme.spacing(RESOURCE_SECTION_PADDING.md),
  },
  [theme.breakpoints.up('lg')]: {
    maxWidth: RESOURCE_SECTION_MAX_WIDTH.lg,
  },
}));
